export default __webpack_public_path__ + "static/media/bg-2of7.bd51fb25.svg";